import { LoaderFunctionArgs, useLoaderData } from 'react-router';
import { urlTournamentConfirmRegister } from '@/urls';
import { clubApi } from '@repo/api-client';
import { AppError, ErrorCode } from '@/lib/http';
import { StatusPage } from '@/components/common/status-page';
import { CheckCircle } from 'lucide-react';
import { Share } from '@/components/ui/share';

function ConfirmRegister() {
  const { playerOne, playerTwo, category, tournament } = useLoaderData<typeof loader>();

  const shareObject = {
    title: 'Inscripción confirmada',
    text: `Inscripción confirmada para el torneo ${tournament.name}!
      Jugador 1: ${playerOne}
      Jugador 2: ${playerTwo}
      Categoría: ${category.name}
      Torneo: ${tournament.name}`,
  };

  return (
    <StatusPage
      title="Inscripción confirmada!"
      description="Inscripción confirmada correctamente"
      icon={CheckCircle}
      effect="confetti"
    >
      <div className="grid grid-cols-6 gap-2 border border-gray-300 rounded-lg p-6 w-full max-w-md shadow-md">
        <span className="text-lg font-bold col-span-2">Jugador 1</span>
        <span className="col-span-4">{playerOne}</span>
        <span className="text-lg font-bold col-span-2">Jugador 2</span>
        <span className="col-span-4">{playerTwo}</span>
        <span className="text-lg font-bold col-span-2">Categoría</span>
        <span className="col-span-4">{category.name}</span>
        <span className="text-lg font-bold col-span-2">Torneo</span>
        <span className="col-span-4">{tournament.name}</span>
        <Share data={shareObject} className="col-span-6 mt-4">
          Compartir
        </Share>
      </div>
    </StatusPage>
  );
}

const loader = async ({ request }: LoaderFunctionArgs) => {
  const token = new URL(request.url).searchParams.get('token');
  if (!token) {
    throw new AppError('Token no encontrado', ErrorCode.UNKNOWN);
  }
  return await clubApi.confirmRegistration(token);
};

export const route = {
  loader,
  element: <ConfirmRegister />,
  path: urlTournamentConfirmRegister(),
};
